import { SignInData } from '@idea2app/ai-work-order-service';
import { Icon } from 'idea-react';
import { observer } from 'mobx-react';
import { Component, FormEvent, PropsWithChildren } from 'react';
import { formToJSON } from 'web-utility';

import { t } from '../model/Translation';
import userStore from '../model/User';
import { ActivityIcon } from './icon';
import * as style from './SessionBox.module.less';

@observer
export class SessionBox extends Component<PropsWithChildren> {
    handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const { email, password } = formToJSON<SignInData>(event.currentTarget);

        userStore.signIn(email, password);
    };

    renderForm = () => (
        <form className={style.formBody} onSubmit={this.handleSubmit}>
            <div className={style.formGroup}>
                <label>{t('username')}</label>
                <div className={style.inputWrapper}>
                    <Icon name="person" className={style.inputIcon} />
                    <input
                        type="text"
                        name="email"
                        placeholder={t('enter_username')}
                        required
                    />
                </div>
            </div>

            <div className={style.formGroup}>
                <label>{t('password')}</label>
                <div className={style.inputWrapper}>
                    <Icon name="lock" className={style.inputIcon} />
                    <input
                        type="password"
                        name="password"
                        placeholder={t('enter_password')}
                        required
                    />
                </div>
            </div>

            <div className={style.checkboxGroup}>
                <label>
                    <input type="checkbox" />
                    <span>{t('remember_login')}</span>
                </label>
            </div>

            <button type="submit" className={style.loginButton}>
                {t('login_now')}
            </button>
        </form>
    );

    render() {
        return userStore.session ? (
            this.props.children
        ) : (
            <div className="position-fixed start-0 top-0 w-100 h-100 bg-white d-flex">
                {/* Left side - System info */}
                <div className={style.leftPanel}>
                    <hgroup className={style.logoSection}>
                        <ActivityIcon className={style.activityIcon} />
                        <div>
                            <h1 className={style.systemTitle}>
                                {t('ai_work_order')}
                            </h1>
                            <p className={style.systemSubtitle}>
                                {t('work_order_ai_assistant')}
                            </p>
                        </div>
                    </hgroup>

                    <ul className={style.statusSection}>
                        <li className={style.statusItem}>
                            <Icon
                                name="check-circle"
                                className={style.statusIcon}
                            />
                            <span>{t('system_normal')}</span>
                        </li>
                        <li className={style.statusItem}>
                            <Icon name="wifi" className={style.statusIcon} />
                            <span>{t('network_normal')}</span>
                        </li>
                    </ul>

                    <p className={style.copyright}>{t('copyright_info')}</p>
                </div>

                {/* Right side - Login form */}
                <div className={style.rightPanel}>
                    <div className={style.loginCard}>
                        <div className={style.header}>
                            <Icon name="shield" className={style.shieldIcon} />
                            <h4>{t('user_login')}</h4>
                            <p>{t('enter_login_info')}</p>
                        </div>

                        {this.renderForm()}
                    </div>
                </div>
            </div>
        );
    }
}
